import { IconButton } from "@mui/material"
import { CommonService } from "../../Service/CommonService"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useParams } from "react-router";
import React, { useEffect, useState } from "react";
import { InventoryApiService } from "../../Service/InventoryApiService";

const ContainerHistory = () => {
    const { id } = useParams<{ id: string }>();
    const history = useHistory();
    const [liquidBarrelData, setLiquidBarrelData] = useState<any>({});

    const routeBack = () => {
        history.goBack();
    };

    useEffect(() => {
        fetchData();
        }, []);
    
    const fetchData = async () => {
        try {
            const response = await InventoryApiService.getContainerBarrelHistoryDetailsById(id);
            setLiquidBarrelData(response.data[0]);
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };
    return (
        <>
            <div
                className="usersList usersList__user container-history-detail"
                style={{ paddingBottom: CommonService.isAdmin() ? 47 : "" }}>
                <div className="usersList__header--wrapper d-flex flex-wrap align-items-center w-100">
                    <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2 position-relative">
                        <div className="d-flex align-items-center gap-2 flex-wrap left-wrapper">
                            {CommonService.isAdmin() && (
                                <>
                                    <div className="back__button" onClick={routeBack}>

                                        <IconButton
                                            aria-label="ArrowBackIcon"
                                            sx={{ backgroundColor: "#FFF" }}
                                        >
                                            <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                                        </IconButton>
                                    </div>

                                    <div className="header--title">
                                        <h1 className="title mb-0">
                                            Container History Detail
                                        </h1>
                                    </div>
                                    <div className="divider mx-2"></div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="user-table-container position-relative">
                    <div className="userTable ">
                        <div className="edit-history-detail-wrapper">
                            <div className="row gy-4">
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Product Name</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyProductName}</p>
                                            {liquidBarrelData.barrelProductName ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Container Id</div>
                                        <div className="value">{liquidBarrelData.barrelNumber ?? "-"}</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Lot No</div>
                                        <div className="value">{liquidBarrelData.lotNo ?? "-"}</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Container Cost</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyBarrelCost}</p>
                                            {liquidBarrelData.barrelCost ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Producer</div>
                                        <div className="value">{liquidBarrelData.producer ?? "-"}</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Mash Bill</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyMashBill}</p>
                                            {liquidBarrelData.barrelMashBill ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">TTB Type</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyTtbType}</p>
                                            {liquidBarrelData.barrelTtbType ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">TTB Class</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyTtbClass}</p>
                                            {liquidBarrelData.barrelTtbClass ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Fill Date</div>
                                        <div className="value">{liquidBarrelData.fillDate}</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Facility</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyFacility}</p>
                                            {liquidBarrelData.barrelFacility ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Container Size</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyBarrelSize}</p>
                                            {liquidBarrelData.barrelSize ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Volume</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyVolume}</p>
                                            {liquidBarrelData.barrelVolume ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Proof</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyProof}</p>
                                            {liquidBarrelData.barrelProof ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Proof Gallons</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyProofGallons}</p>
                                            {liquidBarrelData.proofGallons ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Warehouse</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyRackhouse}</p>
                                            {liquidBarrelData.rackhouse ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Row</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyRow}</p>
                                            {liquidBarrelData.row ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Depth</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyDepth}</p>
                                            {liquidBarrelData.depth ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Height</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyHeight}</p>
                                            {liquidBarrelData.height ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Total Lot Pg</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyTotalLotPg}</p>
                                            {liquidBarrelData.totalLotPg ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">DSP</div>
                                         <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyDsp}</p>
                                            {liquidBarrelData.dsp ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Stage</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyStage}</p>
                                            {liquidBarrelData.stage ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Location</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyLocation}</p>
                                            {liquidBarrelData.location ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Country</div>
                                        <div className="value">
                                            <p className="old-value">{liquidBarrelData.historyCountry}</p>
                                            {liquidBarrelData.country ?? "-"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Shipped</div>
                                        <div className="value">{liquidBarrelData.isShipped ?? "-"}</div>
                                    </div>
                                </div>
                                {/* Enable it when tasting history feature is implemented */}
                                {/* <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Tasting Note</div>
                                        <div className="value">
                                            <button className="view-tasting-btn">
                                                View Tasting Notes
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_16301_110574)">
                                                        <path d="M15.6248 8.61C15.603 8.56063 15.0736 7.38625 13.8967 6.20937C12.3286 4.64125 10.348 3.8125 8.16796 3.8125C5.98796 3.8125 4.00734 4.64125 2.43921 6.20937C1.26234 7.38625 0.730463 8.5625 0.711088 8.61C0.682658 8.67394 0.667969 8.74314 0.667969 8.81312C0.667969 8.8831 0.682658 8.9523 0.711088 9.01625C0.732963 9.06562 1.26234 10.2394 2.43921 11.4163C4.00734 12.9838 5.98796 13.8125 8.16796 13.8125C10.348 13.8125 12.3286 12.9838 13.8967 11.4163C15.0736 10.2394 15.603 9.06562 15.6248 9.01625C15.6533 8.9523 15.668 8.8831 15.668 8.81312C15.668 8.74314 15.6533 8.67394 15.6248 8.61ZM8.16796 12.8125C6.24421 12.8125 4.56359 12.1131 3.17234 10.7344C2.60149 10.1667 2.11583 9.51935 1.73046 8.8125C2.11573 8.10559 2.6014 7.45824 3.17234 6.89062C4.56359 5.51188 6.24421 4.8125 8.16796 4.8125C10.0917 4.8125 11.7723 5.51188 13.1636 6.89062C13.7355 7.4581 14.2223 8.10545 14.6086 8.8125C14.158 9.65375 12.1948 12.8125 8.16796 12.8125ZM8.16796 5.8125C7.57462 5.8125 6.9946 5.98845 6.50125 6.31809C6.0079 6.64774 5.62339 7.11627 5.39632 7.66445C5.16926 8.21263 5.10985 8.81583 5.22561 9.39777C5.34136 9.97971 5.62708 10.5143 6.04664 10.9338C6.4662 11.3534 7.00075 11.6391 7.58269 11.7549C8.16464 11.8706 8.76783 11.8112 9.31601 11.5841C9.86419 11.3571 10.3327 10.9726 10.6624 10.4792C10.992 9.98586 11.168 9.40584 11.168 8.8125C11.1671 8.0171 10.8508 7.25452 10.2884 6.69209C9.72594 6.12966 8.96336 5.81333 8.16796 5.8125ZM8.16796 10.8125C7.7724 10.8125 7.38572 10.6952 7.05682 10.4754C6.72792 10.2557 6.47158 9.94332 6.3202 9.57787C6.16883 9.21241 6.12922 8.81028 6.20639 8.42232C6.28356 8.03436 6.47404 7.67799 6.75375 7.39829C7.03345 7.11858 7.38982 6.9281 7.77778 6.85093C8.16574 6.77376 8.56788 6.81337 8.93333 6.96474C9.29878 7.11612 9.61114 7.37246 9.8309 7.70136C10.0507 8.03026 10.168 8.41694 10.168 8.8125C10.168 9.34293 9.95725 9.85164 9.58218 10.2267C9.2071 10.6018 8.6984 10.8125 8.16796 10.8125Z" fill="#496673" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_16301_110574">
                                                            <rect width="16" height="16" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>

                                            </button>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col">
                                    <div className="field description-field">
                                        <div className="label">Description</div>
                                        <div className="value">
                                            <p
                                                className="old-value"
                                                dangerouslySetInnerHTML={{
                                                    __html: liquidBarrelData?.historyDescription || ""
                                                }}
                                            />
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: liquidBarrelData?.barrelDescription || ""
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ContainerHistory;